import { ref } from "vue";
import { SERVICE_BASE_URL } from "@/config";

/** 全局顶部提示文案（由 KMS sys_config.app_msg 提供；与 bot param_config 同名键可人工保持一致） */
export const appTopMsgText = ref("");

let _inflight = null;
export function setAppTopMsgFromHeartbeat(text) {
    const t = String(text ?? "").trim();
    appTopMsgText.value = t;
}

export async function fetchAppTopMsgOnce() {
    if (_inflight)
        return _inflight;
    _inflight = (async () => {
        const base = String(SERVICE_BASE_URL || "").replace(/\/$/, "");
        const paths = ["/app-msg", "/public/app-msg"];
        try {
            for (const p of paths) {
                const r = await fetch(`${base}${p}`, { method: "GET", credentials: "omit" });
                if (!r.ok)
                    continue;
                const ct = (r.headers.get("content-type") || "").toLowerCase();
                if (!ct.includes("application/json"))
                    continue;
                const j = await r.json();
                const t = String(j?.data?.text ?? "").trim();
                appTopMsgText.value = t;
                break;
            }
        }
        catch {
            /* 保留上次文案 */
        }
        finally {
            _inflight = null;
        }
    })();
    return _inflight;
}
